import ProjectReport from "../ProjectReport";

describe("ProjectReport model", () => {
  test("belongsTo relations", () => {
    expect(
      ProjectReport.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
